import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import ReactDOM from 'react-dom'
import CustomIcon from '@/components/CustomIcon'
import styles from './index.less'

import { useClickOutside } from '@/utils/hooks'

const MARGIN = 12
const PADDING = 12

export default forwardRef(({ syncEl, anchorList, onItemClick }, ref) => {
    const elRef = useRef(null)
    const scrollerRef = useRef(null)

    const updatePosition = () => {
        const syncEle = syncEl()
        const rect = syncEle.getBoundingClientRect()
        const fullElHeight = scrollerRef.current.scrollHeight + PADDING

        const pos = {
            left: rect.left + rect.width + MARGIN,
            top: rect.top + Math.max(rect.height - fullElHeight, 0) / 2,
            maxHeight: rect.height
        }

        elRef.current.setAttribute('style', `left: ${pos.left}px; top: ${pos.top}px; max-height: ${pos.maxHeight}px`)
    }

    useImperativeHandle(ref, () => ({
        show() {
            elRef.current?.classList.add(styles.hasShow)

            updatePosition()
        },
        hide() {
            elRef.current?.classList.remove(styles.hasShow)
        },
        updatePosition
    }))

    useClickOutside({
        rootEl() {
            return document.body
        },
        el() {
            return elRef.current
        },
        handler() {
            elRef.current?.classList.remove(styles.hasShow)
        }
    })

    if (!document.querySelector('#QueryFilterWithConfig')) {
        return null
    }

    return ReactDOM.createPortal(
        <div ref={elRef} className={styles.container}>
            <div ref={scrollerRef} className={styles.scroller}>
                {anchorList.map(item => (
                    <a key={item.name} className={styles.item} onClick={() => onItemClick(item)}>
                        <CustomIcon className={styles.icon} type={item.icon} />
                        <div className={styles.label} title={item.label}>
                            {item.label}
                        </div>
                    </a>
                ))}
            </div>
        </div>,
        document.querySelector('#QueryFilterWithConfig')
    )
})
